import type { DebugPhase } from '@/session/debug';

export type PhaseKey = DebugPhase | 'gap';

/** One hue per stage, resolved from the CSS custom properties so the palette lives in one file. */
export function phaseColor(phase: PhaseKey): string {
  return `var(--color-phase-${phase})`;
}

/**
 * Milliseconds, always, grouped. Every figure in the drawer is compared against the ones above and
 * below it, and a scale that switched to seconds past a threshold would make neighbouring rows
 * incomparable at a glance.
 */
export function formatFigure(ms: number): string {
  return Math.round(ms).toLocaleString('en-US');
}
